"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _excluded = ["styleType", "children"];

var _this = void 0;

/**
 * ConfigInfo.Content
 * @description 配置信息项的内容展示
 */
var Content = function Content(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var styleType = _ref.styleType,
      children = _ref.children,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_style.StyledContent, (0, _extends2["default"])({
    styleType: styleType,
    className: _style.itemContentCompCls
  }, others), children);
}.bind(void 0);

Content.propTypes = {
  /**
   * 样式类型
   */
  styleType: _propTypes["default"].oneOf(["primary", "secondary"]),

  /** @ignore */
  children: _propTypes["default"].node
};
Content.defaultProps = {
  styleType: "primary"
};
var _default = Content;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ConfigInfo/Content.js
// module id = 2098
// module chunks = 6 7 17 18